import { useCallback, useEffect, useState } from 'react';
import { loadRecaptcha } from '../../modules/recaptcha';

export function useRecaptchaToken() {
  const [grecaptchaInstance, setGrecaptchaInstance] = useState(null);

  useEffect(() => {
    loadRecaptcha()
      .then((grecaptcha) => setGrecaptchaInstance(grecaptcha))
      .catch((err) => {
        console.error('Recaptcha failed to load', err);
      });
  }, []);

  const executeRecaptcha = useCallback(
    async (action) => {
      if (!grecaptchaInstance) {
        console.warn('grecaptcha not ready yet');
        return null;
      }
      try {
        const token = await grecaptchaInstance.execute(RECAPTCHA_KEY, {
          action,
        });
        return token;
      } catch (error) {
        console.error('Failed to execute recaptcha', error);
        return null;
      }
    },
    [grecaptchaInstance]
  );

  return executeRecaptcha;
}
